import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  salaCirurgica: boolean,
  centroCirurgico: boolean,
}

interface SalaCirurgicaHospital {
  id: string,
  nome: string,
  hisId?: string,
  hospitalId: string,
  horaFim?: string,
  horaInicio?: string,
  tempoPreparacao?: number,
  centroCirurgicoId?: string,
  tipo?: string;
  status: 'Ativo' | 'Removido',
}

interface CentroCirurgicoHospital {
  id: string,
  nome: string,
  hisId?: string,
  hospitalId: string,
  status: 'Ativo' | 'Removido',
}

@Module({ namespaced: true, name: 'SuporteSalasCentrosCirurgicosStore' })
export default class SuporteSalasCentrosCirurgicosStore extends VuexModule {
  public hospitalId: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    salaCirurgica: false,
    centroCirurgico: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  /** Salas cirúrgicas */
  private paginationSalasCirurgicasDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  public paginationSalasCirurgicas: DataTablePagination = { ...this.paginationSalasCirurgicasDefault }

  get salaPaginationDefault() {
    return this.paginationSalasCirurgicasDefault
  }

  private salasCirurgicasDefault: SalaCirurgicaHospital[] = []
  public salasCirurgicas: SalaCirurgicaHospital[] = [...this.salasCirurgicasDefault]
  private salaCirurgicaDefault: SalaCirurgicaHospital = {
    id: '',
    nome: '',
    hisId: '',
    hospitalId: this.hospitalId,
    horaInicio: '07:00:00',
    horaFim: '19:00:00',
    tempoPreparacao: 30,
    centroCirurgicoId: '',
    status: 'Ativo',
  }

  public salaCirurgica: SalaCirurgicaHospital = { ...this.salaCirurgicaDefault }

  public searchSalaCirurgica: string = ''

  @Mutation
  setSearchSalaCirurgica(value: string) {
    this.searchSalaCirurgica = value
  }

  @Mutation
  setPaginationSalasCirurgicas(val: DataTablePagination) {
    this.paginationSalasCirurgicas = val
  }

  @Mutation
  setSalasCirurgicas(value: SalaCirurgicaHospital[]) {
    this.salasCirurgicas = value
  }

  @Mutation
  clearSalasCirurgicas() {
    this.salasCirurgicas = [...this.salasCirurgicasDefault]
  }

  @Mutation
  setSalaCirurgica(value: SalaCirurgicaHospital) {
    this.salaCirurgica = value
  }

  @Mutation
  clearSalaCirurgica() {
    this.salaCirurgica = { ...this.salaCirurgicaDefault }
  }

  @Action
  async getSalasCirurgicasPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationSalasCirurgicasDefault.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationSalasCirurgicasDefault.rowsPerPage,
        searchText: this.searchSalaCirurgica,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllSalasCirurgicasByHospital(params)

      if (request.success) {
        this.context.commit('setSalasCirurgicas', request.data.salasCirurgicas as SalaCirurgicaHospital[] || [])
        this.context.commit('setPaginationSalasCirurgicas', {
          descending: false,
          page: pagination.page || this.paginationSalasCirurgicasDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationSalasCirurgicasDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationSalasCirurgicasDefault.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setSalasCirurgicas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertSalaCirurgica() {
    const params: SalaCirurgicaHospital = this.salaCirurgica
    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) delete params[key]
      if (['horaInicio', 'horaFim'].includes(key)) {
        params[key] = (value as string).length === 5 ? `${value}:00` : value
      }
    })

    const request = await Apis.Agendamento.SuporteApi.upsertSalaCirurgica({ ...params, hospitalId: this.hospitalId })
    return request
  }

  /** Centros cirúrgicos */
  private paginationCentrosCirurgicosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 25, 50],
  }

  public paginationCentrosCirurgicos: DataTablePagination = { ...this.paginationCentrosCirurgicosDefault }

  get centroCirurgicoPaginationDefault() {
    return this.paginationCentrosCirurgicosDefault
  }

  private centrosCirurgicosDefault: CentroCirurgicoHospital[] = []
  public centrosCirurgicos: CentroCirurgicoHospital[] = [...this.centrosCirurgicosDefault]
  private centroCirurgicoDefault: CentroCirurgicoHospital = {
    id: '',
    nome: '',
    hisId: '',
    hospitalId: this.hospitalId,
    status: 'Ativo',
  }

  public centroCirurgico: CentroCirurgicoHospital = { ...this.centroCirurgicoDefault }
  public searchCentroCirurgico: string = ''

  @Mutation
  setSearchCentroCirurgico(value: string) {
    this.searchCentroCirurgico = value
  }

  @Mutation
  setPaginationCentrosCirurgicos(val: DataTablePagination) {
    this.paginationCentrosCirurgicos = val
  }

  @Mutation
  setCentrosCirurgicos(value: CentroCirurgicoHospital[]) {
    this.centrosCirurgicos = value
  }

  @Mutation
  clearCentrosCirurgicos() {
    this.centrosCirurgicos = [...this.centrosCirurgicosDefault]
  }

  @Mutation
  setCentroCirurgico(value: CentroCirurgicoHospital) {
    this.centroCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = { ...this.centroCirurgicoDefault }
  }

  @Action
  async getCentrosCirurgicosPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationCentrosCirurgicosDefault.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationCentrosCirurgicosDefault.rowsPerPage,
        searchText: this.searchCentroCirurgico,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllCentrosCirurgicosByHospital(params)

      if (request.success) {
        this.context.commit('setCentrosCirurgicos', request.data.centrosCirurgicos as CentroCirurgicoHospital[] || [])
        this.context.commit('setPaginationCentrosCirurgicos', {
          descending: false,
          page: pagination.page || this.paginationCentrosCirurgicosDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationCentrosCirurgicosDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationCentrosCirurgicosDefault.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setCentrosCirurgicos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertCentroCirurgico() {
    const params: CentroCirurgicoHospital = this.centroCirurgico
    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertCentroCirurgico({ ...params, hospitalId: this.hospitalId })
    return request
  }
}
